import type { EligibilityFormData } from '../types'

export const MAX_LICENSE_FILE_SIZE = 10 * 1024 * 1024

export function getTodayForDatePicker() {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

export function formatStoredDate(value: string) {
  if (!value) return ''

  const [month, day, year] = value.split('/')

  if (!month || !day || !year || year.length !== 4) {
    return ''
  }

  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

export function formatLicenseNumber(value: string) {
  return value
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase()
    .slice(0, 20)
}

export function isValidLicenseNumber(value: string) {
  return formatLicenseNumber(value).length >= 5
}

export function toStoredDate(value: string) {
  if (!value) {
    return ''
  }

  const [year, month, day] = value.split('-')
  return `${month}/${day}/${year}`
}

export function getLicenseValidationError(
  formData: EligibilityFormData,
  uploadedLicenseFileName: string
) {
  if (!formData.driverLicenseState.trim()) {
    return "Driver's license state is required."
  }

  const formattedLicenseNumber = formatLicenseNumber(formData.driverLicenseNumber)

  if (!formattedLicenseNumber) {
    return "Driver's license number is required."
  }

  if (!isValidLicenseNumber(formattedLicenseNumber)) {
    return "Driver's license number must be at least 5 letters or numbers."
  }

  if (!formData.licenseIssueDate.trim()) {
    return 'Issue date is required.'
  }

  if (!formData.licenseExpirationDate.trim()) {
    return 'Expiration date is required.'
  }

  if (!uploadedLicenseFileName.trim()) {
    return 'Driver license upload is required.'
  }

  return null
}
